import { Select } from '@cb/apricot-react';
import { styled } from '@mui/system';

const Dropdown = styled(Select)`
  width: 100%;
  height: 3em;
  border: 1px solid #d9d9d9;
  border-radius: 8px;
  padding: 0 12px;
`;

export default Dropdown;
